import { TEAMS_PLATFORM_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { TEAM_GQL_TYPE } from '../constants.tsx';
import type { jiraBusinessTeamFieldFragment } from '../fragment/__generated_apollo__/jiraBusinessTeamFieldFragment.ts';
import type { TransformedTeamField } from '../types.tsx';
import type { TeamTransformersMapping } from './types.tsx';

export const transformTeamField = (): TeamTransformersMapping => ({
	[TEAM_GQL_TYPE]: (field: jiraBusinessTeamFieldFragment): TransformedTeamField | null => {
		if (field.__typename !== TEAM_GQL_TYPE) {
			return null;
		}

		return {
			type: TEAMS_PLATFORM_CF_TYPE,
			fieldId: field.fieldId,
			value: field.selectedTeam
				? {
						id: field.selectedTeam.jiraSuppliedTeamId,
						name: field.selectedTeam.jiraSuppliedName ?? '',
					}
				: null,
		};
	},
});
